import React from 'react'
import { Box, Icon, Tooltip } from '@chakra-ui/react'
import { FiInfo } from 'react-icons/fi'

export interface InfoTooltipProps {
  content: React.ReactNode
  ariaLabel?: string
  maxW?: string
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  content,
  ariaLabel = 'Help information',
  maxW = '320px'
}) => {
  return (
    <Tooltip.Root closeDelay={300} openDelay={200}>
      <Tooltip.Trigger asChild>
        <Box
          as="span"
          display="inline-flex"
          alignItems="center"
          cursor="help"
          p={2}
          m={-2}
          aria-label={ariaLabel}
        >
          <Icon as={FiInfo} boxSize={3.5} color="gray.400" />
        </Box>
      </Tooltip.Trigger>
      <Tooltip.Positioner>
        <Tooltip.Content
          bg="gray.900"
          color="white"
          px={3}
          py={2}
          borderRadius="md"
          fontSize="sm"
          maxW={maxW}
        >
          <Tooltip.Arrow>
            <Tooltip.ArrowTip fill="gray.900" />
          </Tooltip.Arrow>
          {content}
        </Tooltip.Content>
      </Tooltip.Positioner>
    </Tooltip.Root>
  )
}
